// 登录态从 sessionStorage 改到 localStorage 的一次性迁移。
// 原来 token 存在 sessionStorage，它的寿命只有「这个标签页这一次会话」：
// iOS 用描述文件/桌面图标打开是 standalone 模式，系统回收后再开就是新会话，
// token 必丢 → 每次进来都要重新登录。服务端 api_token 本身没有时效，纯前端问题。
// 这段把老会话里还在的 token 搬过来，避免发版那一刻把在线用户踢下线。
try {
  var _oldTk = sessionStorage.getItem('token');
  if (_oldTk && !localStorage.getItem('token')) {
    localStorage.setItem('token', _oldTk);
  }
  sessionStorage.removeItem('token');
} catch (e) {
  // 隐私模式下访存储会抛异常，忽略即可
}

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
let userInfo = JSON.parse(localStorage.getItem('userInfo'))?JSON.parse(localStorage.getItem('userInfo')) :{};
let appInfo = JSON.parse(localStorage.getItem('appInfo'))?JSON.parse(localStorage.getItem('appInfo')) :{};
let messageNum = localStorage.getItem("messageNum") || 0 ;
let token = localStorage.getItem("token") || '';

export default new Vuex.Store({
  //state存放状态,
  state: {
    userInfo,
    token,

    messageNum,
    appInfo
  },
  //getter为state的计算属性
  getters: {
    
  },
  //mutations可更改状态的逻辑，同步操作
  mutations: {
    changToken(state){

      state.token = localStorage.getItem('token') || ''; 
    },
    changUserInfo(state){
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        state.userInfo = userInfo ;
    },
    changappInfo(state){
      let appInfo = JSON.parse(localStorage.getItem('appInfo'))
      state.appInfo = appInfo ;
  }
    ,changMessageNum(state){
      let show = localStorage.getItem('show');
      state.messageNum = show ? 0 : localStorage.getItem('messageNum'); 
    }
  },
  //提交mutation，异步操作
  actions: {
    
  },
  // 将store模块化
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js